import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType, ObjectUtils } from '@cv-invision/core';
import { PublicRecordModel } from '@cv-invision/cv.invision-views.ux';
import { PTablePublicRecordDataModel } from '../../model/p-table-comp-grid-data.model';
import { Subject, takeUntil } from 'rxjs';
import { UserIdleService } from 'angular-user-idle';

@Component({
	selector: 'cv-invision-ux-public-record-modal',
	templateUrl: './public-record-modal.component.html',
	styleUrls: ['./public-record-modal.component.scss'],
})
export class PublicRecordModalComponent extends AbstractModal implements OnInit, OnDestroy {

	compIdentifier = null;
	compPR = null;
	compPhoto = 'assets/img/placeholder/No-file-asset.png';
	calculatedData: PTablePublicRecordDataModel[] = [];
	private atComponentDestroy = new Subject();

	constructor(private userIdle: UserIdleService,) {
		super();
	}

	ngOnInit(): void {
		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm btn-light',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		this.buttons.push(cancelButton);
		this.compIdentifier = (this.data.comp || '').toUpperCase();

		const selectedCompPR = (this.data.publicRecords || []).filter((record: PublicRecordModel) => {
			return record.propertyIdentifier?.toUpperCase() === this.compIdentifier
		});

		if (selectedCompPR.length) {
			this.compPR = selectedCompPR[0];
		}

		this.prepareData();

		//If onTimeout is excute then close the modal.
		this.userIdle.onTimeout().pipe(takeUntil(this.atComponentDestroy)).subscribe(() => {
			setTimeout(() => {
				this.onDismiss();
			}, 100);
		});
	}

	/**
	 * Calculate Rows data with Header, Value and Public Records
	 */
	// prepareData(): void {
	// 	const name = (this.compIdentifier || '').toLowerCase();

	// 	if (this.data.compHeader[0][name] !== 'N/A') {
	// 		this.compPhoto = this.data.compHeader[0][name];
	// 	}

	// 	const compData = ObjectUtils.recursiveDeepCopy(this.data.compData);
	// 	compData.unshift(this.data.compHeader[2]);
	// 	compData.forEach((item: any) => {

	// 		const value = item[name];

	// 		this.calculatedData.push({
	// 			header: item.headerName,
	// 			selected: value,
	// 			publicRecord: '',
	// 			type: item.type
	// 		});
	// 	});
	// }

	/**
	 * Calculate Rows data with Header, Value and Public Records
	 */
	prepareData(): void {
		// check if there is an image path is exist.
		const photo = this.data.compHeader.find((data: PTablePublicRecordDataModel) => data.key === 'photo')
		if (photo.value !== 'N/A') {
			this.compPhoto = photo.value;
		}

		// deep copy compData to calculatedData array then unshift 'Address' section in to the array
		this.calculatedData = ObjectUtils.recursiveDeepCopy(this.data.compData);
		const address = this.data.compHeader.find((data: PTablePublicRecordDataModel) => data.key === 'address')
		this.calculatedData.unshift(address);
	}

	onDismiss(): void {
		super.onCancel();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.unsubscribe();
	}
}
